import axios, { AxiosError } from 'axios';
import { conexao } from '../../../../offline/conexao';

export const errorInterceptor = (error: AxiosError) => {

  // Sem resposta do servidor (rede caída, timeout) — o sistema passa a
  // trabalhar offline (ver shared/offline). Com resposta, está alcançável.
  if (!axios.isCancel(error)) {
    if (error.response) conexao.marcarOnline();
    else if (error.request) conexao.marcarOffline();
  }
   
  if (error.message === 'Network Error') {
    return Promise.reject(new Error('Erro de conexão.'));
  }

  if (error.response?.status === 401) {
    const isLoginRoute = window.location.pathname === '/login';

    if (!isLoginRoute) {
      localStorage.removeItem('APP_ACCESS_TOKEN');
      axios.defaults.headers.common.Authorization = '';
  
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }

  return Promise.reject(error);
};